import client from '@/plugins/axios-plugin';

export default async function login(email= '', password = ''){
    let res = null;
    try {
        res = await client.post('/auth/login', {
            email: email,
            password: password
        })
    } catch (error) {
    }
    return res;
};
